export enum OrderEditType {
  Draft = 'draft',
  Order = 'order',
}
